<template>
  <div v-if="invoices">
    <div v-for="invoice in invoices" :key="invoice.id" class="border py-3 px-4 flex mb-1">
      <div class="w-1/2 font-semibold">
        <a
          :href="invoice.download_url"
          class="text-gray-900 hover:underline"
        >{{ invoice.invoice_number }}</a>
      </div>
      <div class="w-1/4 flex items-center">
        <div class="w-20">{{ invoice.total | formatMoney }}</div>
        <div
          class="inline-block rounded px-2 text-sm font-semibold leading-relaxed"
          :class="invoice.is_paid ? 'bg-green-200 text-green-900': 'bg-gray-200 text-gray-900'"
        >{{ invoice.is_paid ? 'betaald' : 'open'}}</div>
      </div>
      <div class="w-1/4 text-right text-gray-700">{{ invoice.created_at | formatDay }}</div>
    </div>
    <div v-if="!invoices.length" class="text-gray-500">Nog geen facturen</div>
  </div>
</template>

<script>
export default {
  props: {
    invoices: Array
  }
};
</script>